goog.provide("shadow.js.shim.module$src$svg$type$thumbnails$meta_single_image_svg$default");
shadow.js.shim.module$src$svg$type$thumbnails$meta_single_image_svg$default = shadow.js.shim.module$src$svg$type$thumbnails$meta_single_image_svg.default;
